import { BaseComponent } from "utils/base-component"
import { Tabs } from "components/controls/tabs"
import "./filter-overlay.scss"

interface MapWithShops {
  toggleShops(): void
  showShops: boolean
}

type Config = {
  map: MapWithShops
}

export class FilterOverlay extends BaseComponent<Config> {
  static cssClass = "filter-overlay"

  private map!: MapWithShops

  init() {
    this.map = this.config.map

    Tabs.init(this.root, {
      onChange: (key: string) => {
        const showShops = key === "shops"
        if (showShops !== this.map.showShops) {
          this.map.toggleShops()
        }
      },
    })
  }
}
